/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The VersionResponse model module.
 * @module model/VersionResponse
 * @version 1.0
 */
class VersionResponse {
    /**
     * Constructs a new <code>VersionResponse</code>.
     * @alias module:model/VersionResponse
     */
    constructor() { 
        
        VersionResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>VersionResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/VersionResponse} obj Optional instance to populate.
     * @return {module:model/VersionResponse} The populated <code>VersionResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new VersionResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('origin')) {
                obj['origin'] = ApiClient.convertToType(data['origin'], 'String');
            }
            if (data.hasOwnProperty('userHostAddress')) {
                obj['userHostAddress'] = ApiClient.convertToType(data['userHostAddress'], 'String');
            }
            if (data.hasOwnProperty('environment')) {
                obj['environment'] = ApiClient.convertToType(data['environment'], 'String');
            }
            if (data.hasOwnProperty('assemblyVersion')) {
                obj['assemblyVersion'] = ApiClient.convertToType(data['assemblyVersion'], 'String');
            }
            if (data.hasOwnProperty('fileVersion')) {
                obj['fileVersion'] = ApiClient.convertToType(data['fileVersion'], 'String');
            }
            if (data.hasOwnProperty('version')) {
                obj['version'] = ApiClient.convertToType(data['version'], 'String');
            }
            if (data.hasOwnProperty('dbVersion')) {
                obj['dbVersion'] = ApiClient.convertToType(data['dbVersion'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>VersionResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>VersionResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['origin'] && !(typeof data['origin'] === 'string' || data['origin'] instanceof String)) {
            throw new Error("Expected the field `origin` to be a primitive type in the JSON string but got " + data['origin']);
        }
        // ensure the json data is a string
        if (data['userHostAddress'] && !(typeof data['userHostAddress'] === 'string' || data['userHostAddress'] instanceof String)) {
            throw new Error("Expected the field `userHostAddress` to be a primitive type in the JSON string but got " + data['userHostAddress']);
        }
        // ensure the json data is a string
        if (data['environment'] && !(typeof data['environment'] === 'string' || data['environment'] instanceof String)) {
            throw new Error("Expected the field `environment` to be a primitive type in the JSON string but got " + data['environment']);
        }
        // ensure the json data is a string
        if (data['assemblyVersion'] && !(typeof data['assemblyVersion'] === 'string' || data['assemblyVersion'] instanceof String)) {
            throw new Error("Expected the field `assemblyVersion` to be a primitive type in the JSON string but got " + data['assemblyVersion']);
        }
        // ensure the json data is a string
        if (data['fileVersion'] && !(typeof data['fileVersion'] === 'string' || data['fileVersion'] instanceof String)) {
            throw new Error("Expected the field `fileVersion` to be a primitive type in the JSON string but got " + data['fileVersion']);
        }
        // ensure the json data is a string
        if (data['version'] && !(typeof data['version'] === 'string' || data['version'] instanceof String)) {
            throw new Error("Expected the field `version` to be a primitive type in the JSON string but got " + data['version']);
        }
        // ensure the json data is a string
        if (data['dbVersion'] && !(typeof data['dbVersion'] === 'string' || data['dbVersion'] instanceof String)) {
            throw new Error("Expected the field `dbVersion` to be a primitive type in the JSON string but got " + data['dbVersion']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
VersionResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
VersionResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
VersionResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
VersionResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
VersionResponse.prototype['contentsReward'] = undefined;

/**
 * @member {String} origin
 */
VersionResponse.prototype['origin'] = undefined;

/**
 * @member {String} userHostAddress
 */
VersionResponse.prototype['userHostAddress'] = undefined;

/**
 * @member {String} environment
 */
VersionResponse.prototype['environment'] = undefined;

/**
 * @member {String} assemblyVersion
 */
VersionResponse.prototype['assemblyVersion'] = undefined;

/**
 * @member {String} fileVersion
 */
VersionResponse.prototype['fileVersion'] = undefined;

/**
 * @member {String} version
 */
VersionResponse.prototype['version'] = undefined;

/**
 * @member {String} dbVersion
 */
VersionResponse.prototype['dbVersion'] = undefined;






export default VersionResponse;

